import { render } from "./WebService.vue?vue&type=template&id=afbe7960"
import script from "./WebService.vue?vue&type=script&lang=js"
export * from "./WebService.vue?vue&type=script&lang=js"

import "./WebService.vue?vue&type=style&index=0&id=afbe7960&lang=css"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__